import React from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import numeral from 'numeral';
import { toDecimal4 } from 'src/utils/toDecimal';

function Footer(props) {
  const { columns, totals, length } = props;

  return (
    <TableRow>
      <TableCell
        style={{
          fontWeight: 900
        }}
      >
        Total :
      </TableCell>{' '}
      <TableCell
        style={{
          fontWeight: 900
        }}
      >
        {length}
      </TableCell>
      {columns.map(column => (
        <TableCell
          key={column?.key ?? column.fld}
          style={{
            width: column.width,
            minWidth: column.width,
            fontWeight: 900
          }}
          align={column?.align ?? 'left'}
        >
          {column?.total
            ? numeral(toDecimal4(totals?.[column.fld] ?? 0)).format('0,0.00')
            : ''}
        </TableCell>
      ))}
    </TableRow>
  );
}

export default Footer;
